var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_564_50245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.243 17.9981H3V13.7551L14.435 2.32013C14.6225 2.13266 14.8768 2.02734 15.142 2.02734C15.4072 2.02734 15.6615 2.13266 15.849 2.32013L18.678 5.14913C18.8655 5.33666 18.9708 5.59097 18.9708 5.85613C18.9708 6.12129 18.8655 6.3756 18.678 6.56313L7.243 17.9981ZM3 19.9981H21V21.9981H3V19.9981Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_564_50245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.958ca8e9a636fdb10095f35d0448712c.svg";
export { ForwardRef as ReactComponent };